"use strict";

var PromptList = require("app/shared/components/Prompt/prompt-list");
var Intl = require("intl");
var ReactIntl = require("react-intl");
var PRIVACY_MODE = {
  "OPEN": "1",
  "CLOSED": "2"
};

var PromptAccountPrivacyChange = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    currentPrivacyValue: React.PropTypes.oneOf([PRIVACY_MODE.OPEN, PRIVACY_MODE.CLOSED]).isRequired,
    onConfirm: React.PropTypes.func.isRequired,
    isOpen: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return {
      isOpen: true
    };
  },
  alertText: function() {
    if (this.props.currentPrivacyValue == PRIVACY_MODE.OPEN) {
      return this.getIntlMessage("prompt.account_privacy_change.closed_to_open");
    } else if (this.props.currentPrivacyValue == PRIVACY_MODE.CLOSED) {
      return this.getIntlMessage("prompt.account_privacy_change.open_to_closed");
    }
  },
  render: function() {
    var props = {
      text: this.getIntlMessage("prompt.account_privacy_change.title"),
      checkboxItems: [{checked:false, text: this.alertText()}],
      buttonText: this.getIntlMessage("shared_components.button.confirm"),
      buttonClasses: "btn btn-primary",
      autoClose: true,
      isOpen: this.props.isOpen,
      onClose: this.props.onClose,
      onConfirm: this.props.onConfirm,
      type: "confirm"
    };

    return (
      <PromptList {...props} />
    );
  }
});

module.exports = PromptAccountPrivacyChange;



// WEBPACK FOOTER //
// ./app/shared/components/Prompt/prompt-account-privacy-change.jsx